<template>
  <div
    class="trackingContainer viewContainer"
    :class="{ navBarActive: $store.state.navBar }"
  >
    <v-snackbar absolute top :timeout="3000" v-model="snackbar">{{
      snackbarText
    }}</v-snackbar>
    <Header
      :loading="loading"
      title="Configuraciones"
      :showSearh="false"
      :showNewButton="false"
    />

    <div class="main">
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-switch
            label="¿Puede cambiar punto inicial?"
            v-model="business.canChangeStartingPoint"
            :loading="loading"
            @change="
              update($event, {
                canChangeStartingPoint: business.canChangeStartingPoint,
              })
            "
          ></v-switch>
        </v-col>

        <v-col cols="12" sm="6" md="6">
          <v-switch
            label="¿Puede cambiar puntos secundarios?"
            :loading="loading"
            @change="
              update($event, {
                canChangeSecondaryPoints: business.canChangeSecondaryPoints,
              })
            "
            v-model="business.canChangeSecondaryPoints"
          ></v-switch>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { db, fb } from "@/firebase";
import Header from "@/components/header.vue";

export default {
  name: "Login",
  components: {
    Header,
  },
  data() {
    return {
      business: {},
      user: {},
      loading: false,
      snackbarText: "",
      snackbar: false,
    };
  },
  mounted() {
    if (this.$store.state.user.role != "admin") {
      return this.$route.push("/map");
    }

    this.$store.commit("setLoading", "Cargando...");
    this.$store.commit("setNavBar", true);
    // this.showSearch(false);

    if (this.$store.state.user) {
      this.init();
    } else {
      this.$store.subscribe((mutation, state) => {
        if (mutation.type == "setUser") {
          this.init();
        }
      });
    }
  },
  methods: {
    // ...mapActions(["showSearch"]),
    update(e, data) {
      data.modifiedBy = this.user[".key"];
      data.modifiedAt = new Date();

      // this.$store.commit("setLoading", "Actualizando...");
      this.loading = true;

      db.collection("businessesCorporative")
        .doc(this.$store.state.user.businessID)
        .update(data)
        .then((response) => {
          this.loading = false;
          this.snackbarText =
            "Información del comercio actualizada correctamente.";
          this.snackbar = true;
          // this.$store.commit("setLoading", "");
          // this.$store.commit(
          //   "setNotification",
          //   `Información del comercio actualizada correctamente.`
          // );
          // this.$store.commit("setNotification", true);
        })
        .catch((err) => {
          // this.$store.commit("setLoading", "");

          this.reverseStatus(data);
          this.loading = false;
          this.snackbarText =
            "Ocurrió un error inesperado, inténtelo nuevamente.";
          this.snackbar = true;
          // this.$store.commit(
          //   "setNotification",
          //   `Ocurrió un error inesperado, inténtelo nuevamente.`
          // );
          // this.$store.commit("setNotification", true);
        });
    },

    reverseStatus(data) {
      if (data.hasOwnProperty("canChangeStartingPoint")) {
        this.business.canChangeStartingPoint = !data.canChangeStartingPoint;
      }

      if (data.hasOwnProperty("canChangeSecondaryPoints")) {
        this.business.canChangeSecondaryPoints = !data.canChangeSecondaryPoints;
      }

      if (data.hasOwnProperty("allowNotifications")) {
        this.business.allowNotifications = !data.allowNotifications;
      }

      if (data.hasOwnProperty("geofenceActive")) {
        this.business.geofenceActive = !data.geofenceActive;
      }
    },

    async init() {
      await this.$binding(
        "business",
        db
          .collection(`businessesCorporative`)
          .doc(this.$store.state.user.businessID)
      );

      await this.$binding(
        "user",
        db.collection("users").doc(this.business.ochoUserId)
      );

      this.$store.commit("setLoading", false);
    },
  },
};
</script>

<style lang="scss" scoped>
// .viewContainer {
//   padding: 20px;
//   transition: 0.3s all;
//   padding-top: 30px;
//   height: 100vh;
//   box-sizing: border-box;
// }

// .titleContainer {
//   display: flex;
//   justify-content: space-between;
//   height: 52px;

//   h1 {
//     font-size: 28px;
//     line-height: 28px;
//     span {
//       font-size: 16px;
//       line-height: 16px;
//       display: block;
//       color: #666;
//     }
//   }

//   .actions {
//     display: flex;
//     justify-content: space-between;

//     .actionBtn {
//       appearance: none;
//       border: none;
//       outline: none;
//       margin-left: 10px;
//       font-weight: bold;
//       color: white;
//       text-decoration: none;
//       box-sizing: content-box;
//       text-align: center;
//       padding: 5px;
//       min-width: 32px;
//       height: 32px;
//       border-radius: 18px;
//       display: flex;
//       justify-content: center;
//       flex-direction: column;
//       align-items: center;
//       transition: 0.4s 0.1s all cubic-bezier(0.44, 0.1, 0.28, 1.59),
//         0.4s 0.5s transform cubic-bezier(0.44, 0.1, 0.28, 1.59);
//       color: white;
//       background-color: #FF1744;
//       box-shadow: 0px 0px 20px rgba(#FF1744, 0.8);
//       cursor: pointer;

//       &.inactive {
//         background-color: #aaa;
//         box-shadow: 0px 0px 20px rgba(#333, 0.2);
//       }

//       i {
//         font-size: 21px;
//       }

//       span {
//         margin: 0 15px;
//         font-size: 16px;
//       }
//     }
//   }
// }
// .trackingContainer {
//   text-align: left;
//   &.navBarActive {
//     padding-left: 130px;
//   }

//   .errandsHeader {
//     margin-top: 50px;
//     height: 48px;
//     line-height: 16px;
//     border-radius: 18px;
//     background-color: #fff;
//     display: flex;
//     flex-direction: row;
//     justify-content: space-around;
//     align-items: center;
//     filter: drop-shadow(0px 0px 3px rgba(#000000, 0.4));
//     padding: 10px 28px;
//     position: relative;
//     z-index: 1000;

//     span {
//       font-weight: bold;
//       color: #111;
//       border-right: 1px solid #eee;
//       width: 100%;
//       text-align: left;
//       padding: 10px 20px;

//       &.date {
//         min-width: 175px;
//       }

//       &:last-of-type {
//         border-right: none;
//       }
//     }
//   }
// }

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  max-width: 90px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #FF1744;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2a7cc0;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
  max-width: 90px;
}

.slider.round:before {
  border-radius: 50%;
}

.message {
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(0, 0, 0, 0.774);
}

.message i {
  font-size: 60px !important;
  color: rgba(102, 102, 102, 0.459);
}

.add-cards {
  padding: 15px;
  color: white;
  background-color: #FF1744;
  cursor: pointer;
  border: none;
  border-radius: 20px;
}

.card-main {
  color: black;
  display: grid;
  grid-template-columns: 20% 75%;
  margin-top: 20px;
  align-items: center;

  i {
    font-size: 80px !important;
    color: gray;
  }

  p {
    font-size: 20px;
    text-align: justify;
  }
}

.card-color {
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

.help {
  margin-top: 30px;
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;

  // span {
  i {
    margin-right: 10px;
    color: #000000a6;
    font-size: 25px !important;
  }
  a {
    color: #000000a6;
    text-decoration: none;
    // padding-bottom: 10px;
  }
  // }
}

.item {
  display: flex;
  align-items: center;
  padding: 0 10px 10px 10px;
  margin-top: 30px;
}

.tag-setting {
  margin-left: 20px;
  color: black;
}

.main {
  background-color: white;
  padding: 20px;
  border-radius: 20px;
  display: grid;
  grid-template-columns: auto auto auto;
  margin-top: 20px;
}
</style>
